export default "__VITE_ASSET__DT$pPpY4__"